/*============================TBC================================*/
let TBCorder = {
  merchantKey: "405341679-ddd352c5-dd8f-4bba-ae8d-498356898432",
  campaignId: "529",
  priceTotal: null,
  products: [],
};
$(".mini-cart-products")
  .find("li")
  .each(function () {
    const TBC_product = {
      name: null,
      price: null,
      quantity: null,
    };

    TBC_product.name = $(this).find(".title").text();
    let temp_price = parseFloat($(this).find(".price").data("crvalue") / 100 / 1, 10).toFixed(2);

    TBC_product.quantity = parseFloat($(this).find(".qty").data("crvalue"));
    TBC_product.price = parseFloat(temp_price * TBC_product.quantity);
    TBCorder.products.push(TBC_product);
  });
let total = TBCorder.products.reduce((sum, product) => sum + product.price, 0);
TBCorder.priceTotal = parseFloat(total.toFixed(2));

var tbc_json = JSON.stringify(TBCorder);

// console.log(TBCorder)

function rTBC() {
  var settings = {
    url: "https://ganvadeba.online/tbc/api",
    method: "POST",
    data: JSON.stringify(TBCorder),
  };

  $.ajax(settings).done(function (response) {
    console.log(response);
    window.location.href = response;
  });
}

/*============================Credo================================*/

let credo_order = $("#credo_json").text();
//  console.log(lala)

let check = "{{ md5 | md5 }}";
let myJSON = JSON.stringify(credo_order);
let credolink = `https://ganvadeba.online/credo/c.php?check=${check}&products=${credo_order}`;

//credo redirect

function rCREDO() {
  window.location.href = credolink;
}

/*============================Crystal================================*/

// var crOrder = {
//        "products": [],
//   		"vendor_id":"7210"
//    }

//    $('.mini-cart-products').find('li').each(function(){
//        const crystal_product = {
//            "title": null,
//            "price": null,
//            "quantity": null,
//        }

//        crystal_product.title = $(this).find(".title").text();
//        crystal_product.price = $(this).find(".price").data("crvalue") / 100 ;
//        crystal_product.quantity = $(this).find(".qty").data("crvalue") ;
//        crOrder.products.push(crystal_product);

//    });
//    //let crystal_total = $(".sub-total").data("crvalue") /100 ;
//    //crOrder.total_sum = crystal_total;

// //console.log(crjson)

//    var crjson = JSON.stringify(crOrder)
//    //console.log(crjson)
//    var credlink = `https://crystalone.ge/online_installment/7210?cart=${crjson}`;

// function rCRYSTAL(){
//     window.location.href= credlink ;
// }

function rCRYSTAL() {
  window.location.href = "/pages/crystal";
}

/*============================BOG================================*/

function rBOG() {
  window.location.href = "/pages/bog";
}

/*============================TERA================================*/

let teraorder = {
  Culture: "ka",
  StoreId: "0J0G",
  Products: [],
};

$(".mini-cart-products")
  .find("li")
  .each(function () {
    const tera_product = {
      Name: null,
      Amount: null,
      CashAmount: null,
      Quantity: null,
    };

    tera_product.Name = $(this).find(".title").text();
    tera_product.Quantity = $(this).find(".qty").data("crvalue");
    tera_product.Amount = ($(this).find(".price").data("crvalue") / 100) * $(this).find(".qty").data("crvalue");
    tera_product.CashAmount = ($(this).find(".price").data("crvalue") / 100) * $(this).find(".qty").data("crvalue");
    teraorder.Products.push(tera_product);
  });

var tera_json = JSON.stringify(teraorder);
var tera_url = {};

function rTERA() {
  var settings = {
    url: "https://ganvadeba.online/tera/api.php",
    method: "POST",
    data: JSON.stringify(teraorder),
  };

  $.ajax(settings).done(function (response) {
    tera_url = JSON.parse(response);
    window.location.href = `https://online.terabank.ge/installments/products/${tera_url.storeSessionId}`;
  });
}
